import api from './api';

export interface MyProfile {
  user_id: string;
  customer_id: string;
  email: string;
  role: string;
  first_name?: string | null;
  last_name?: string | null;
  company_name?: string | null;
  phone_number?: string | null;
  last_login?: string | null;
  created_at?: string;
}

export async function getMyProfile(): Promise<MyProfile> {
  const res = await api.get('/auth/me');
  return res.data.user as MyProfile;
}

export async function updateMyProfile(data: {
  phone_number?: string | null;
  company_name?: string | null;
}): Promise<MyProfile> {
  const res = await api.put('/auth/me/profile', data);
  return res.data.user as MyProfile;
}
